import { apiBaseUrl } from "shared/config/appConfig";

export const getCategories = async (signal) => {
  const response = await fetch(`${apiBaseUrl}/categories?page=0&size=200&sort=name,asc`, {
    signal,
  });

  if (!response.ok) {
    throw new Error("Failed to fetch categories");
  }

  const data = await response.json();
  return data.content;
};

export const getExercises = async (categoryIds = [], signal) => {
  const categoryQuery = categoryIds.length > 0 ? `categoryIds=${categoryIds.join(",")}&` : "";
  const response = await fetch(`${apiBaseUrl}/exercises?${categoryQuery}page=0&size=200`, {
    signal,
  });

  if (!response.ok) {
    throw new Error("Failed to fetch exercises");
  }

  const data = await response.json();
  return data.content;
};
